import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

export default function Header() {
  return (
    <div className="d-flex align-items-center m-1">
      <div className="col-12">
        <h1 className="title gray-800 mb-0 fs-3 fs-md-1">
          <Link className="pointer sendto-back text-decoration-none" to="/workflow-automation">
            Automation
          </Link>
          <span> / Stopped Instances</span>
        </h1>
      </div>
    </div>
  );
}
